// Handles both message types, pushes raw event as-is
window.addEventListener("message", (event) => {
    if (event.data.type === "form_events_ok" || event.data.type === "form_send_ok") {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: event.data.type,
            ...event.data.payload
        });
    }
});

// Handles both message types, pushes mapped format for client
window.addEventListener("message", (event) => {
    if (event.data.type === "form_events_ok" || event.data.type === "form_send_ok") {
        const payload = event.data.payload || {};

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "form_send_ok",
            "user_data.phone_number": payload.phone_number ?? payload.phone ?? "",
            "user_data.email": payload.email ?? ""
        });
    }
});